import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { qprActions } from '../../../../Actions';
import { qprService } from '../../../../Services';
import SideNav from './Partials/SideNav';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';

const ProgressPPTForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [selected_file, setSelectedFile] = useState(null);

  const [pp, setPP] = useState(qpr.progress_ppt && qpr.progress_ppt.pp && qpr.progress_ppt.pp.length > 0? qpr.progress_ppt.pp: []);

  useEffect( () => {
    if(typeof qpr.progress_ppt == "undefined") {
      qprService.progressPPT(qpr_id).then(rslt => {
        qpr.progress_ppt = rslt.data.progress_ppt;
        qpr.form_validation = JSON.parse(rslt.data.progress_ppt.form_validation);
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setPP(qpr.progress_ppt.pp);
      });
    }
  }, []);

  const [files, setFiles] = useState('');
  const [fileSize, setFileSize] = useState(true);
  const [fileType, setfileType] = useState(true);
  
  const handleChange = (e) => {
    setFiles(e.target.files);
  }

  const submitForm = () => {
    const formData = new FormData();
    formData.append(`submit_status`, 1);
    qpr.form_validation.progress_ppt.submit_status = 1;
    formData.append(`form_validation`, JSON.stringify(qpr.form_validation));
    
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > 10240000){
        setFileSize(false);
        setSubmitted(false);
        return;
      }
      if (files[i].type != "application/pdf"){
        setfileType(false);
        setSubmitted(false);
        return;
      }
      formData.append(`charts`, files[i]);
    }
    qprService.progressPPTSave(formData, qpr_id).then(res => {
      qpr.progress_ppt = res.data.progress_ppt;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      setPP(qpr.progress_ppt.pp);
      setSubmitted(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setFileSize(true);
    setSubmitted(true);
    submitForm();
  }

  const deletePP = (pp_id) => {
    qprService.progressPPTDelete(qpr_id, pp_id).then(res => {
      qpr.progress_ppt.pp = res.data.pp;
      if(res.data.form_validation) {
        qpr.progress_ppt.form_validation = res.data.form_validation;
        qpr.form_validation.progress_ppt.submit_status = null;
      }
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      setPP(qpr.progress_ppt.pp);
    });
  } 

  const MyModal = () => {
    return (
      <>
        <div className={"modal fade"} id="myModal">
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
            
              <div className="modal-header">
                {/* <h1 className="modal-title">Modal Heading</h1> */}
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                {selected_file && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/uploads"+selected_file },
                      // { uri: require(selected_file) }, // Local File
                    ]
                  } 
                />
                }
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Progress PPT</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                          <div className='singel-form'>
                            <p>Maximum file size: 10MB</p>
                            <input type="file" className='custom-file-input1' id="customFile" name='chart' onChange={handleChange} multiple />
                            {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                            {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                            {!fileType && <p style={{color:'red'}}>Only PDF file is allowed</p>}
                          </div>
                          <div className='singel-form'>
                            <button type="submit" className="btn btn-info">
                            {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Upload</span>}
                            </button>
                          </div>
                          <hr/>
                          <div className="row">
                            {pp.length>0 && pp.map((val, key) => {
                              return (
                                <div className='col-md-6 mt-2' key={key}>
                                  <div className="media border p-2" style={{height: "100px"}}>
                                    <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#myModal" onClick={() => setSelectedFile(val.chart)} />
                                    <div className="media-body pl-2">
                                      <p className='text-wrap' style={{width:"200px"}}>{val.name}</p>
                                    </div>
                                    <div className="clearfix">
                                      <FontAwesomeIcon icon={faTrashAlt} onClick={() => deletePP(val.id)} className="float-right" style={{height: "10px", cursor: "pointer"}} />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MyModal />
      </section>
    </>
  );
};

export default ProgressPPTForm;